import React from "react";
import LandingPage from "./pages/LandingPage";
import { UserManagement } from "./pages/UserManagement";
import { SPLotPage } from "./pages/SPLots";
import { MintRegistration } from "./pages/MintRegistration";
import { WorkflowPage } from "./pages/WorkflowPage";
import { HelpSupport } from "./pages/HelpSupport";
import { ContactInfo } from "./pages/ContactInfo";
import { Feedback } from "./pages/Feedback";
import { LabelTemplates } from "./pages/LabelTemplates";
import { DeviceManagement } from "./pages/DeviceManagement";
import { TechnicianView } from './pages/TechnicianView';
import { ProcessingWorkflow } from "./pages/ProcessingWorkflow";
import EventsReport from "./components/common/EventsReport";
//const HarvestReq = React.lazy(() => import("./components/InSeason/HarvestReq"));
const lazyWithRetry = (
  factory: () => Promise<{ default: React.ComponentType<any> }>
) =>
  React.lazy(() =>
    factory().catch((error) => {
      console.error("Chunk load failed, reloading page", error);
      window.location.reload(); 
      return { default: () => null };
    })
  );

  const HarvestReq = lazyWithRetry(() =>
  import("./components/InSeason/HarvestReq")
);


export const PATH_NAMES = {
    home: "/",
    UserManagement: "userManagement",
    SPLotPage: "splot",
    MintRegistration: "mintRegistration",
    HelpSupport: "help-support",
    ContactInfo: "contact-info",
    Feedback: "feedback",
    WorkflowPage: "workflow",
    LabelTemplates: "label-templates",
    DeviceManagement: "device-management",
    TechnicianView: "technician",
    ProcessingWorkflow: "processing-workflow",
    HarvestReq: "harvest-req",
    EventsReport: "events-report"
} as const
export interface PathRoute {
    path: string
    Component: React.ComponentType
    exact?: boolean
}
export const ROUTES: PathRoute[] = [
    {
        path: PATH_NAMES.home,
        Component: LandingPage
    },
    {
        path: PATH_NAMES.UserManagement,
        Component: UserManagement
    },
    {
        path: PATH_NAMES.SPLotPage,
        Component: SPLotPage
    },
    {
        path: PATH_NAMES.MintRegistration,
        Component: MintRegistration
    },
    {
        path: PATH_NAMES.WorkflowPage,
        Component: WorkflowPage
    },
    {
        path: PATH_NAMES.HelpSupport,
        Component: HelpSupport
    },
    {
        path: PATH_NAMES.ContactInfo,
        Component: ContactInfo
    },
    {
        path: PATH_NAMES.Feedback,
        Component: Feedback
    },
    {
        path: PATH_NAMES.LabelTemplates,
        Component: LabelTemplates
    },
    {
        path: PATH_NAMES.MintRegistration,
        Component: MintRegistration
    },
    {
        path: PATH_NAMES.DeviceManagement,
        Component: DeviceManagement
    },
    {
        path: PATH_NAMES.TechnicianView,
        Component: TechnicianView
    },
    {
        path: PATH_NAMES.ProcessingWorkflow,
        Component: ProcessingWorkflow
    },
      {
        path: PATH_NAMES.HarvestReq,
        Component: HarvestReq
        },
        {
                path: PATH_NAMES.EventsReport,
                Component: EventsReport
    }
]


